import { EntityFilterType } from '../../shared-platform/models/constants/entity-filter-type';
import { UserAccessType } from '../../shared-platform/models/constants/user-access-types';

export class EntityFilter {
    constructor(
        public entityId: string,
        public name: string,
        public entityFilterType: string
    ) {}

    static from(value: Pick<EntityFilter, 'entityId' | 'name' | 'entityFilterType'>): EntityFilter {
        return value instanceof EntityFilter
            ? value
            : new EntityFilter(value.entityId, value.name, value.entityFilterType);
    }
}

export class EntityFilterConstants {

    static readonly Network: EntityFilter = Object.freeze(
        new EntityFilter(UserAccessType.Network, 'Network Data', EntityFilterType.Network)
    );
}

export class EntityFilterCollection extends Array<EntityFilter> {
    constructor(...items: EntityFilter[]) {
        super(...items);
    }

    get associations(): EntityFilterCollection {
        return new EntityFilterCollection(...this.filter(item => item.entityFilterType === EntityFilterType.Association));
    }

    get customers(): EntityFilterCollection {
        return new EntityFilterCollection(...this.filter(item => item.entityFilterType === EntityFilterType.Shipper));
    }

    get network(): EntityFilter | undefined {
        return this.find(item => item.entityFilterType === EntityFilterType.Network);
    }

    get hasAssociations(): boolean {
        return this.filter(item => item.entityFilterType === EntityFilterType.Association).length > 0;
    }

    get hasCustomers(): boolean {
        return this.filter(item => item.entityFilterType === EntityFilterType.Shipper).length > 0;
    }

    get hasNetwork(): boolean {
        return this.filter(item => item.entityFilterType === EntityFilterType.Network).length > 0;
    }
}
